// export const apiUrl = `http://127.0.0.1:8000/api/admin`;
export const apiUrl = `https://papernotes-app-d03a5b3a18c1.herokuapp.com/api/admin`;